export default __webpack_public_path__ + "static/media/s6.095e382c.jpg";